import get from 'lodash/fp/get.js';
import { createSelector } from 'reselect';
import makeSelectVisibleFields from './makeSelectVisibleFields.js';

const selectFieldNames = (_, props) => props.fields;

const makeSelectAtLeastOneFieldInArrayIsVisible = form => {
  const selectVisibleFields = makeSelectVisibleFields(form);

  return createSelector(selectFieldNames, selectVisibleFields, (fields, visibleFields) =>
    visibleFields && Array.isArray(fields) && fields.length > 0
      ? fields.some(field => get(field, visibleFields) === true)
      : true
  );
};

export default makeSelectAtLeastOneFieldInArrayIsVisible;
